import { Box } from "@chakra-ui/layout";
import {AspectRatio, useDisclosure, Image, ChakraProps} from "@chakra-ui/react";
import { VideoPlayButton } from "components/atoms/VideoPlayButton";
import { VideoModal } from "components/molecules/VideoModal";
import { IProduct } from "interfaces/product.interface";
import React from "react";

export const ProductMastheadVideo = ({
  product,
  cover,
coverMaxWidth,
}: {
  product: IProduct;
  cover?: string;
  coverMaxWidth?: ChakraProps["maxW"];
}) => {
  const { video, color } = product;

  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <VideoModal isOpen={isOpen} onClose={onClose} src={video.file.file.url} />
      <Box flex={1} pl={{ base: 0, lg: 16 }} py={12}>
        <Box pos="relative">
          <Box
            position="absolute"
            width="80%"
            left="10%"
            rounded="lg"
            height="120%"
            bg={`${color}.100`}
            top={"-5%"}
          />

          <AspectRatio
            ratio={16 / 9}
            rounded="lg"
            overflow="hidden"
            shadow="lg"
            cursor="pointer"
            onClick={onOpen}
          >
            <Box pos="relative" bg="gray.100">
              <Box position="absolute" zIndex={1} w={20} h={20}>
                <VideoPlayButton />
              </Box>
              <Image src={cover || video.cover.file.url} maxW={coverMaxWidth || 'lg' } mx="auto" />
            </Box>
          </AspectRatio>
        </Box>
      </Box>
    </>
  );
};
